<template>
  <v-app id="logout">
    <v-container bg fill-height grid-list-md text-xs-center>
        <v-layout row wrap align-center>
          <v-flex id="displayText" :class="{'headline': $vuetify.breakpoint.smAndUp}">
            Please wait, you are being logged out...
          </v-flex>
        </v-layout>
      </v-container>
  </v-app>
</template>
<script>
/* global session */
export default {
  computed: {
    session () {
      return this.store.state.session;
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    session.logout();
  }
};
</script>
<style lang="css" scoped>
#displayText {
  font-family: 'Roboto', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/pages/Logout.vue